// organizationStaff
// 员工管理
import layout from '@/layout/index.vue'
export default {
  path: '/organization',
  component: layout,
  name: 'organizationStaff',
  redirect: '/organization/role',
  meta: {
    title: '组织架构',
    icon: 'zuzhi'
  },
  children: [
    {
      path: '/organization/staff',
      component: () => import('@/views/organization/staff/index.vue'),
      meta: {
        title: '员工管理',
        icon: 'zuzhi'
      }
    }
  ]
}
